
import React from 'react';
import Summary from './Summary';
import Checkout from './Checkout';

function BookingSummary() {
  return (
    <div className="min-h-screen flex flex-col md:flex-row gap-6 md:gap-12">
      
      {/* Summary Component */}
      <div className="w-full md:w-3/5">
        <Summary />
      </div>

      {/* Checkout Component */}
      <div className="w-full md:w-4/12">
        <Checkout />
      </div>
      
    </div>
  );
}

export default BookingSummary;
